import React, {useState} from "react";
import {Card, Pagination} from 'antd';
import 'antd/dist/antd.css';
import {ListWrapper} from "../Styles";
import {colors} from '../../Constants/Constants'
import {layoutGenerator} from "react-break";

const screen = layoutGenerator({
    mobile: 0,
    phablet: 550,
    tablet: 768,
    desktop: 992,
});

const pageSize = 25;

const List = ({refference, selectedPlaces, entries, size, height}) => {

    const [minValue, setMinValue] = useState(0);
    const [maxValue, setMaxValue] = useState(entries.length);


    const handleChange = (range) => {
        setMinValue(range[0])
        setMaxValue(range[1]);
    }
    const card = (i) => {
        return (
            <a target="_blank" href={i.link}> <Card
                hoverable={true}
                extra={<h3 style={{
                    fontFamily: `'Work Sans', sans-serif`,
                    color: colors.lightWhite,
                    marginBottom: '0px'
                }}>{i.price} ALL</h3>}
                headStyle={{
                    fontFamily: `'Work Sans', sans-serif`,
                    marginBottom: '0px',
                    background: colors.orange,
                    color: colors.lightWhite
                }} title={i.title}
                style={{width: size, height: height, marginBottom: '10px'}}>
                <p style={{fontFamily: `'Work Sans', sans-serif`, color: 'black'}}>{i.details1}</p>
                <div style={{lineHeight: 'normal'}}><p
                    style={{fontFamily: `'Work Sans', sans-serif`, color: 'black'}}>{i.details2}</p></div>
            </Card> </a>
        )
    }

    entries = entries.sort((a, b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0));

    const entriesCard = () => {
        if (selectedPlaces.length === 0 && entries.length < pageSize) {
            return entries.map(i => {
                return card(i)
            })
        } else if (selectedPlaces.length === 0 && entries.length > pageSize) {
            return entries.slice(minValue, maxValue).map(i => {
                return card(i)
            })
        }
        return (
            selectedPlaces.sort((a, b) => (a.price > b.price) ? 1 : ((b.price > a.price) ? -1 : 0)).map(i => {
                return card(i)
            })
        )
    };

    return (
        <div ref={refference}>
            <ListWrapper>
                {entriesCard()}
            </ListWrapper>
            {selectedPlaces.length === 0 && entries.length > pageSize ? <Pagination
                style={{textAlign: 'center'}}
                defaultCurrent={1}
                showTotal={(total, range) => {
                    handleChange(range)
                }}
                defaultPageSize={pageSize}
                total={entries.length}
                showSizeChanger={false}
            /> : null}
        </div>

    );
}

export default List;
